/* eslint-disable @typescript-eslint/naming-convention */
import { HandType } from '@ps/web-poker-types';

import { legacyHandTypeToAssetNameMap } from '../types';

import {
  BASE_POKER_STR,
  BUY_IN_RANGES,
  Structure,
  TILE_IMAGE_FORMAT,
  getRailCdnBaseUrl
} from './game';
import { getBuyInCategory, isSwapShowFusion } from './helpers';
import { TableFlags2 } from './types';

interface DefaultsType {
  useStructure: boolean;
  pathDef?: string;
}

const defaults: DefaultsType = {
  useStructure: true,
  pathDef: undefined
};

// @todo logic needs to be reviewed/refactored asap
const cashGamePathDefs: Record<string, DefaultsType> = {
  None: defaults,
  Badugi: defaults,
  Holdem: defaults,
  '5 Omaha': {
    ...defaults,
    pathDef: '5Omaha'
  },
  Omaha: defaults,
  Draw: defaults,
  'Single Draw 27': {
    ...defaults,
    pathDef: 'single_draw_27'
  },
  Stud: {
    ...defaults,
    pathDef: 'stud'
  },
  Razz: {
    ...defaults,
    pathDef: 'razz'
  },
  '3 Draw 27': {
    ...defaults,
    pathDef: '3_draw_27'
  },
  '3 Draw A5': {
    ...defaults,
    pathDef: '3_draw_a5'
  },
  Courchevel: {
    ...defaults,
    pathDef: 'courchevel'
  },
  '6 Omaha': {
    ...defaults,
    pathDef: '6Omaha'
  }, // PYR-92617
  'Split Holdem': {
    useStructure: false,
    pathDef: 'splitholdem'
  }, // PYR-52675
  'Split Omaha': defaults,
  'Showtime Holdem': {
    useStructure: false,
    pathDef: 'showtime'
  }, // PYR-64093
  'Showtime Omaha': defaults,
  Fusion: {
    useStructure: false,
    pathDef: 'fusion'
  }, // PYR-66528 - starts as hold'em, switches to omaha
  'Unfold Classic': {
    useStructure: false,
    pathDef: 'unfold_classic'
  },
  'Unfold Max': defaults, // not implemented yet!  don't forget to update playingaudit.cpp
  '6+ Holdem': {
    useStructure: false,
    pathDef: '6plus_holdem'
  }, // PYR-73403
  'Deep Water Holdem': {
    useStructure: false,
    pathDef: 'deep_water'
  }, // PYR-82834
  'Deep Water Omaha': {
    useStructure: false,
    pathDef: 'deep_water'
  }, // PYR-82834
  'Swap Holdem': {
    useStructure: false,
    pathDef: 'swap'
  }, // PYR-107599
  'All-In Poker': {
    useStructure: false,
    pathDef: 'all_in_poker'
  }, // PYR-115738
  Hose: {
    useStructure: false,
    pathDef: 'mixed'
  },
  Horse: {
    useStructure: false,
    pathDef: 'mixed_horse'
  },
  // New set, Bug #8800:
  'Nl 8-Game': {
    useStructure: false,
    pathDef: 'mixed'
  },
  'Mixed Holdem': {
    useStructure: false,
    pathDef: 'mixed'
  },
  'Mixed Omaha Hl': {
    useStructure: false,
    pathDef: 'mixed'
  },
  'Pl Holdem Pl Omaha': {
    useStructure: false,
    pathDef: 'plh_plo'
  },
  'Nl Triple Stud': {
    useStructure: false,
    pathDef: 'triple_stud'
  },
  'Nl Holdem Pl Omaha': {
    useStructure: false,
    pathDef: 'mixed_nlhplo'
  },
  'Nl Mixed Omaha': {
    useStructure: false,
    pathDef: 'mixed'
  }
};

const morphGames = [
  HandType.ALL_IN_POKER,
  HandType.DEEPWATER_HOLDEM,
  HandType.UNFOLD_CLASSIC,
  HandType.UNFOLD_MAX,
  HandType.SIX_PLUS_HOLDEM
];

export default function imageCashFormatter(
  game: HandType,
  structure: number,
  buyIn: number,
  cap: number,
  isHiLo: number,
  tableFlags2: number,
  isThemeV2Image?: boolean
) {
  const pathInfo = cashGamePathDefs[legacyHandTypeToAssetNameMap[game]] || defaults;
  const gameStr = (
    (pathInfo && pathInfo.pathDef) ||
    legacyHandTypeToAssetNameMap[game]
  ).toLowerCase();
  const structureStr = pathInfo.useStructure ? Structure[structure] : '';
  const hiLoStr = isHiLo === 1 ? '_hl' : '';

  const baseUrl = getRailCdnBaseUrl(!!isThemeV2Image);
  const defaultCashImgUrl = `${baseUrl}${BASE_POKER_STR}${
    structureStr ? `${structureStr.toLowerCase()}_` : ''
  }${gameStr}${hiLoStr}_${getBuyInCategory(buyIn, BUY_IN_RANGES)}${TILE_IMAGE_FORMAT}`;

  if (morphGames.includes(game)) {
    return defaultCashImgUrl;
  }

  if (isSwapShowFusion(game)) {
    return `${baseUrl}${BASE_POKER_STR}${gameStr}${TILE_IMAGE_FORMAT}`;
  }

  if (cap !== 0) {
    return `${baseUrl}${BASE_POKER_STR}${
      structureStr.toLowerCase() || 'nl'
    }_cap${TILE_IMAGE_FORMAT}`;
  }

  // eslint-disable-next-line no-bitwise
  if (tableFlags2 & TableFlags2.TABLESCRIPT_FLAG2_STEALTH_TABLE) {
    return `${baseUrl}${BASE_POKER_STR}stealth${TILE_IMAGE_FORMAT}`;
  }

  return defaultCashImgUrl;
}
